// @flow
import { createContext } from 'react';

export const SPStreamingProjectContext = createContext({});
